module.exports = __webpack_public_path__ + "static/media/StatsIcon03.3c1aee66.svg";